(function () {
  'use strict';

  var S = 'stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"';

  var UNION_JACK =
    '<svg class="np-uj" viewBox="0 0 60 36" xmlns="http://www.w3.org/2000/svg">' +
      '<rect x="0.9" y="0.9" width="58.2" height="34.2" rx="2" fill="none" stroke="currentColor" stroke-width="1.6" opacity="0.55"/>' +
      '<g stroke="currentColor" stroke-width="1.5" opacity="0.5">' +
        '<line x1="2" y1="2" x2="58" y2="34"/><line x1="58" y1="2" x2="2" y2="34"/>' +
      '</g>' +
      '<g fill="currentColor">' +
        '<rect x="25.6" y="1" width="8.8" height="34"/><rect x="1" y="13.6" width="58" height="8.8"/>' +
      '</g>' +
    '</svg>';

  var STAMPS = [
    { key: 'flag',   top: 'UK',        bottom: 'FORMULATED', svg: UNION_JACK },
    { key: 'flask',  top: '3RD PARTY', bottom: 'LAB TESTED', svg: '<svg viewBox="0 0 24 24" ' + S + '><path d="M9 3h6"/><path d="M10 3v6.5L5.2 18A2 2 0 0 0 7 21h10a2 2 0 0 0 1.8-3L14 9.5V3"/><path d="M7.5 15h9"/></svg>' },
    { key: 'shield', top: 'GMP',       bottom: 'APPROVED',   svg: '<svg viewBox="0 0 24 24" ' + S + '><path d="M12 3l7 3v6c0 4.5-3 7.8-7 9-4-1.2-7-4.5-7-9V6z"/><path d="M9 12l2 2 4-4"/></svg>' },
    { key: 'leaf',   top: 'NO',        bottom: 'FILLERS',    svg: '<svg viewBox="0 0 24 24" ' + S + '><path d="M20 4C10 4 4 9 4 16v4"/><path d="M20 4c0 9-5 13-11 13H4"/></svg>' }
  ];

  var TRUCK = '<svg viewBox="0 0 24 24" ' + S + '><rect x="1.5" y="6" width="13" height="10" rx="1.5"/><path d="M14.5 9.5H18l3.5 3v3.5h-7z"/><circle cx="6" cy="18" r="1.8"/><circle cx="17.5" cy="18" r="1.8"/></svg>';

  function data() {
    var el = document.getElementById('np-buybox-data');
    if (!el) return {};
    try { return JSON.parse(el.textContent) || {}; } catch (e) { return {}; }
  }

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  function buildBuyBox(info) {
    if (info.querySelector('.np-bb')) return;

    var d = data();
    var anchor = info.querySelector('.main_product_price');
    if (!anchor) return;

    var wrap = el('div', 'np-bb');
    var html = '';

    if (d.summary) html += '<p class="np-bb__summary">' + d.summary + '</p>';

    if (d.bullets) {
      var lines = String(d.bullets).split(/\r?\n/).filter(function (l) { return l.trim(); });
      if (lines.length) {
        html += '<ul class="np-bb__points">';
        lines.forEach(function (l) {
          html += '<li><span class="np-bb__tick" aria-hidden="true"></span>' + l.trim() + '</li>';
        });
        html += '</ul>';
      }
    }

    var meta = [];
    if (d.count) meta.push(d.count);
    if (d.serving) meta.push(d.serving + ' per serving');
    if (d.supply) meta.push(d.supply + ' supply');
    if (meta.length) html += '<p class="np-bb__meta">' + meta.join(' <span>&bull;</span> ') + '</p>';

    html += '<div class="np-bb__stamps">';
    STAMPS.forEach(function (s) {
      html += '<span class="np-bb__stamp np-bb__stamp--' + s.key + '">' +
                '<span class="np-bb__stamp-ring" aria-hidden="true">' + s.svg + '</span>' +
                '<span class="np-bb__stamp-txt"><b>' + s.top + '</b>' + s.bottom + '</span>' +
              '</span>';
    });
    html += '</div>';

    wrap.innerHTML = html;
    anchor.insertAdjacentElement('afterend', wrap);
  }

  function injectNote(info) {
    if (info.querySelector('.np-buybox-note')) return;
    var atc = info.querySelector('.main_product_action_btns_wrapper');
    if (!atc) return;
    atc.insertAdjacentElement('afterend', el('div', 'np-buybox-note',
      '<span class="np-buybox-note__ico" aria-hidden="true">' + TRUCK + '</span>' +
      '<span>Free UK delivery &middot; most orders arrive in 24&ndash;48 hours</span>'));
  }

  function setMainImage(url, alt) {
    var main = document.querySelector('.main_product_featured_image');
    if (!main) return;
    var img = main.querySelector('img');
    var link = main.querySelector('a');
    if (!img) return;
    img.classList.add('np-swapping');
    var next = new Image();
    next.onload = function () {
      img.setAttribute('src', url);
      img.removeAttribute('srcset');
      if (alt) img.setAttribute('alt', alt);
      if (link) link.setAttribute('href', url);
      window.requestAnimationFrame(function () { img.classList.remove('np-swapping'); });
    };
    next.onerror = function () { img.classList.remove('np-swapping'); };
    next.src = url;
  }

  function wireThumbnails() {
    var strip = document.querySelector('.main_product_thumbnails_media');
    if (!strip || strip.dataset.npWired) return;
    var mainWrap = document.querySelector('.main_product_featured_image');
    if (!mainWrap) return;
    strip.dataset.npWired = '1';

    var mainImg = mainWrap.querySelector('img');
    var originalSrc = mainImg ? (mainImg.currentSrc || mainImg.getAttribute('src')) : '';
    var originalAlt = mainImg ? mainImg.getAttribute('alt') : '';

    var first = el('div', 'main_product_thumbnail_image np-thumb np-thumb--active',
      '<button type="button" class="np-thumb__btn" aria-label="View main image"><img src="' + originalSrc + '" alt="" loading="lazy"></button>');
    first.dataset.full = originalSrc;
    first.dataset.alt = originalAlt || '';
    strip.insertBefore(first, strip.firstChild);

    Array.prototype.forEach.call(strip.children, function (thumb) {
      thumb.classList.add('np-thumb');
      var anchor = thumb.querySelector('a[data-fancybox]');
      if (anchor) {
        thumb.dataset.full = anchor.getAttribute('href');
        thumb.dataset.alt = anchor.getAttribute('aria-label') || '';
        anchor.removeAttribute('data-fancybox');
        anchor.setAttribute('role', 'button');
        anchor.setAttribute('href', 'javascript:void(0)');
      }
      thumb.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (!thumb.dataset.full) return;
        setMainImage(thumb.dataset.full, thumb.dataset.alt);
        Array.prototype.forEach.call(strip.children, function (t) { t.classList.remove('np-thumb--active'); });
        thumb.classList.add('np-thumb--active');
      });
    });
  }

  function init() {
    var info = document.querySelector('.main_product_info_inner');
    if (info) {
      buildBuyBox(info);
      injectNote(info);
      wireThumbnails();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var tries = 0;
  var iv = setInterval(function () {
    tries++;
    init();
    if (tries > 15) clearInterval(iv);
  }, 300);
})();
